module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/373.45c9c64c.png";